import type { INavTypeIcon } from './INavTypeIcon';
import { typeNav } from './navigation';

/**
 * Іконки меню, які імпортер навігації ставить поверх MOD_ICON прототипу (Tools/import_v4_navigation.py ICON_OVERRIDES): «Верховна Рада»
 * (mandate) у меню «Комітети» — landmark. Плитки переліків «Налаштувань» прототип малює modIco без них — layout-grid.
 */
const MENU_ONLY_ICONS: Record<string, string> = { mandate: 'landmark' };

/**
 * Плитка типу запису в переліках «Налаштувань» («Встановлені модулі», «Каталог модулів», «Форми») як modIco прототипу v4: іконка й тон
 * таблиці, без іконок, що є лише в меню (Верховна Рада — layout-grid, як у прототипі).
 */
export function tileNav(moduleKey: string, rtKey: string): INavTypeIcon {
  const nav = typeNav(moduleKey, rtKey);
  return { icon: MENU_ONLY_ICONS[rtKey] === nav.icon ? 'layout-grid' : nav.icon, tone: nav.tone };
}
